'use client'

import React, { createContext, useState, useContext, useEffect } from 'react'
import { creatorsData, targetsData } from '../data/business'

//* Tipagem dos filtros
export type FilterType = {
    id: number
    label: string
    color?: string
    image?: string
}

export type FiltersType = {
    search: string
    products: FilterType[]
    targets: FilterType[]
    creators: FilterType[]
    companies: FilterType[]
    time: 'today' | 'thisWeek' | 'nextWeek' | 'expired' | null
}

type CommonType = {
    filtersOptions: FiltersType
    setFiltersOptions: (value: FiltersType) => void
}

const Common = createContext<CommonType | undefined>(undefined)

export const CommonProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [filtersOptions, setFiltersOptions] = useState<FiltersType>({
        search: '',
        products: [],
        targets: [],
        creators: [],
        companies: [],
        time: null
    })

    useEffect(() => {
        //* Carrega filtros (empresas vêm dos negócios carregados, ver BusinessDrawerFilter)
        setFiltersOptions(prev => ({ ...prev, creators: creatorsData }))
        setFiltersOptions(prev => ({ ...prev, targets: targetsData }))
    }, [])

    return (
        <Common.Provider
            value={{
                filtersOptions,
                setFiltersOptions
            }}
        >
            {children}
        </Common.Provider>
    )
}

export function useCommon() {
    const context = useContext(Common)
    if (context === undefined) {
        throw new Error('useCreate must be used within a CommonProvider')
    }
    return context
}
